// extracted by mini-css-extract-plugin
export var cardContainer = "_ob-0";
export var cardHeader = "_ob-2";
export var collapsedState = "_ob-3";
export var dragHandle = "_ob-5";
export var dragHandleIcon = "_ob-6";
export var dragging = "_ob-1";
export var titleArea = "_ob-4";